import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import SymbolSearchPopup from "./SymbolSearchPopup";


export default function SetPage(){

    const [cookies] = useCookies(['uuid']);

    // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
    const[uid,setUID] = useState(0);
    const[nickname,setNickname] = useState('');

    const [isChecked, setIsChecked] = useState(false);

    const [symbolList, setSymbolList] = useState([]);

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(() => {
      if (!cookies.uuid) {
        alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
        window.location.href = `/LoginAts`;
        return;
      } else {
        const uuid = cookies.uuid;
        fetchUserInfo(uuid);
      }
    }, []);

    useEffect(() => {
      console.log('클라이언트 uuid');
    }, [cookies.uuid]);
  
    const fetchUserInfo = (uuid) => {
      fetch(`/SetPage/user?uuid=${uuid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          const user = data[0];
          if(user.royal_possible === 0 || user.royal_possible === '0' || user.royal_possible === null) {
            alert(`${user.nickname} 님은 Royal version 사용권한이 없습니다.`);
            window.location.href = `/SelectPage`;
            return;
          }
          setUID(user.uid);
          setNickname(user.nickname);
          fetchLists(user.uid);
        })
        .catch(error => {
          alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
          window.location.href = `/LoginAts`;
          return;
        });
    };
    
    // selectedlevel, entry, waiting list 받아오기
    const fetchLists = (uid) => {
      fetch(`/startcheck/searchlevel?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          if(data[0].super_user === "8"){
            setLevelCheck(data[0].super_user);  
          }else{
            setLevelCheck(data[0].selectedLevel);
          }
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });

      fetch(`/startcheck_royal/list_entry?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, e_items, setE_Items);
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });
  
      fetch(`/startcheck_royal/list_wait?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, w_items, setW_Items);
        })
        .catch(error => {
          console.error('Waiting List 가져오기 오류:', error);
          alert(error);
        });
    };
  
    const updateList = (data, list, setList) => {
      for (let i = 0; i < data.length; i++) {
        if (!isItemInList(data[i].symbol, list)) {
          setList(prevList => [...prevList, data[i].symbol]);
        }
      }
    };

    const isItemInList = (item, list) => {
      return list.includes(item);
    };

    const[seed,setSeed] = useState('basic');

    const[symbol,setSymbol] = useState('default');

    const[first_usdt,setFirstUsdt] = useState(10);
    const[leverage_info, setLeverage] = useState(20);
    const[turning_ratio, setTurningRatio] = useState(0.5);

    const[total_benefit,setTotalBenefit] = useState(0);
    const[cross_benefit,setCrossBenefit] = useState(0);

    const[benefit_ratio,setBenefitRatio] = useState(1);
    const[losscut_ratio,setLosscutRatio] = useState(1);

    const[standard_ratio,setStandardRatio] = useState(1);

    const[entry_usdt_1, setEntryUsdt_1] = useState(10);
    const[entry_usdt_2, setEntryUsdt_2] = useState(10);
    const[entry_usdt_3, setEntryUsdt_3] = useState(10);
    const[entry_usdt_4, setEntryUsdt_4] = useState(10);
    const[entry_usdt_5, setEntryUsdt_5] = useState(10);
    const[entry_usdt_6, setEntryUsdt_6] = useState(10);
    const[entry_usdt_7, setEntryUsdt_7] = useState(10);
    const[entry_usdt_8, setEntryUsdt_8] = useState(10);
    const[entry_usdt_9, setEntryUsdt_9] = useState(10);

    const[entry_ratio_1, setEntryRatio_1] = useState(3);
    const[entry_ratio_2, setEntryRatio_2] = useState(3);
    const[entry_ratio_3, setEntryRatio_3] = useState(3);
    const[entry_ratio_4, setEntryRatio_4] = useState(3);
    const[entry_ratio_5, setEntryRatio_5] = useState(3);
    const[entry_ratio_6, setEntryRatio_6] = useState(3);
    const[entry_ratio_7, setEntryRatio_7] = useState(3);
    const[entry_ratio_8, setEntryRatio_8] = useState(3);
    const[entry_ratio_9, setEntryRatio_9] = useState(3);

    const[cover_ratio,setCoverRatio] = useState(0);

    const[entry_candle,setEntryCandle] = useState('3m');

    const[mode,setMode] = useState('forward');

    //////////////////////////////////////////////////////////
    
    const[firstusdtValid, setFirstusdtValid] = useState(true);
    const[leverageValid,setLeverageValid] = useState(true);
    const[turningratioValid, setTurningratioValid] = useState(true);

    const[totalbenefitValid, setTotalbenefitValid] = useState(true);
    const[crossbenefitValid, setCrossbenefitValid] = useState(true);

    const[benefitratioValid, setBenefitratioValid] = useState(true);
    const[losscutratioValid, setLosscutratioValid] = useState(true);

    const[standardratioValid, setStandardratioValid] = useState(true);

    const[entryusdtValid_1,setEntryUsdtValid_1] = useState(true);
    const[entryusdtValid_2,setEntryUsdtValid_2] = useState(true);
    const[entryusdtValid_3,setEntryUsdtValid_3] = useState(true);
    const[entryusdtValid_4,setEntryUsdtValid_4] = useState(true);
    const[entryusdtValid_5,setEntryUsdtValid_5] = useState(true);
    const[entryusdtValid_6,setEntryUsdtValid_6] = useState(true);
    const[entryusdtValid_7,setEntryUsdtValid_7] = useState(true);
    const[entryusdtValid_8,setEntryUsdtValid_8] = useState(true);
    const[entryusdtValid_9,setEntryUsdtValid_9] = useState(true);

    const[entryratioValid_1,setEntryRatioValid_1] = useState(true);
    const[entryratioValid_2,setEntryRatioValid_2] = useState(true);
    const[entryratioValid_3,setEntryRatioValid_3] = useState(true);
    const[entryratioValid_4,setEntryRatioValid_4] = useState(true);
    const[entryratioValid_5,setEntryRatioValid_5] = useState(true);
    const[entryratioValid_6,setEntryRatioValid_6] = useState(true);
    const[entryratioValid_7,setEntryRatioValid_7] = useState(true);
    const[entryratioValid_8,setEntryRatioValid_8] = useState(true);
    const[entryratioValid_9,setEntryRatioValid_9] = useState(true);

    const[coverratioValid, setCoverratioValid] = useState(true);
    
    const[trend,setTrend] = useState('trend');
    const[direction,setDirection] = useState('direction');
    const[entry_standard,setEntryStandard] = useState('trendstrength');

    const[setlevel, setLevelCheck] = useState(0);

    const[notAllow, setNotAllow] = useState(true);

    const[e_items, setE_Items] = useState([]);
    const[w_items, setW_Items] = useState([]);

    const handleCheckboxChange = (event) => {
      setIsChecked(event.target.checked);
    };

    const handleTrend = (e) => {
      setTrend(e.target.value);
        };

    const handleDirection = (e) => {
      setDirection(e.target.value);
        };
    
    const[search,setSearch] = useState(false);

    const[trade_start,setTradeStart] = useState(false);
    
    const[benefit_stop,setBenefit_stop] = useState(false);
    const[benefit_cancel,setBenefit_cancel] = useState(false);

    const[currentCoin_stop,setCurrentCoin_stop] = useState(false);
    const[allCoin_stop,setAllCoin_stop] = useState(false);

    const[end,setEnd] = useState(false);
    
    // 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //
    const handleEntryCandle = (e) => {
      setEntryCandle(e.target.value);
        };
      
    const handleMode = (e) => {
      setMode(e.target.value);
        };

    const handleFirstUsdt = (e) => {
      const newFirstusdt = e.target.value.trim();
      setFirstUsdt(newFirstusdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newFirstusdt)) {
          setFirstusdtValid(true);
          } 
        else {
          setFirstusdtValid(false);
          }
        };
    
    const handleLeverage = (e) => {
      const newLeverage = e.target.value.trim();
      setLeverage(newLeverage);
        const regex = 
        /^\d*$/;
        if (regex.test(newLeverage)) {
          setLeverageValid(true);
          } 
        else {
          setLeverageValid(false);
          }
        };

    const handleTurningratio = (e) => {
      const newTurningratio = e.target.value.trim();
      setTurningRatio(newTurningratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newTurningratio)) {
          setTurningratioValid(true);
          } 
        else {
          setTurningratioValid(false);
          }
        };
        
    const handleTotalBenefit = (e) => {
      const newTotalbenefit= e.target.value.trim();
      setTotalBenefit(newTotalbenefit);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newTotalbenefit)) {
          setTotalbenefitValid(true);
          } 
        else {
          setTotalbenefitValid(false);
          }
        };

    const handleCrossbenefit = (e) => {
      const newCrossbenefit = e.target.value.trim();
      setCrossBenefit(newCrossbenefit);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newCrossbenefit)) {
          setCrossbenefitValid(true);
          } 
        else {
          setCrossbenefitValid(false);
          }
        };
    
    const handleBenefitratio = (e) => {
      const newBenefitratio = e.target.value.trim();
      setBenefitRatio(newBenefitratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newBenefitratio)) {
          setBenefitratioValid(true);
          } 
        else {
          setBenefitratioValid(false);
          }
        };

    const handleLosscutratio = (e) => {
      const newLosscutratio = e.target.value.trim();
      setLosscutRatio(newLosscutratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newLosscutratio)) {
          setLosscutratioValid(true);
          } 
        else {
          setLosscutratioValid(false);
          }
        };

    const handleStandardratio = (e) => {
      const newStandardratio = e.target.value.trim();
      setStandardRatio(newStandardratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newStandardratio)) {
          setStandardratioValid(true);
          } 
        else {
          setStandardratioValid(false);
          }
        };
    
    // 진입 USDT 유효성 검사 //// 진입 USDT 유효성 검사 //// 진입 USDT 유효성 검사 //
    const handleEntryUsdt_1 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_1(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_1(true);
          } 
        else {
          setEntryUsdtValid_1(false);
          }
        };
    const handleEntryUsdt_2 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_2(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_2(true);
          } 
        else {
          setEntryUsdtValid_2(false);
          }
        };
    const handleEntryUsdt_3 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_3(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_3(true);
          } 
        else {
          setEntryUsdtValid_3(false);
          }
        };
    const handleEntryUsdt_4 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_4(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_4(true);
          } 
        else {
          setEntryUsdtValid_4(false);
          }
        };
    const handleEntryUsdt_5 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_5(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_5(true);
          } 
        else {
          setEntryUsdtValid_5(false);
          }
        };
    const handleEntryUsdt_6 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_6(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_6(true);
          } 
        else {
          setEntryUsdtValid_6(false);           
          }
        };
    const handleEntryUsdt_7 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_7(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_7(true);
          } 
        else {
          setEntryUsdtValid_7(false);
          }
        };
    const handleEntryUsdt_8 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_8(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_8(true);
          } 
        else {
          setEntryUsdtValid_8(false);
          }
        };
    const handleEntryUsdt_9 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_9(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_9(true);
          } 
        else {
          setEntryUsdtValid_9(false);
          }
        };

        
    const handleEntryRatio_1 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_1(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_1(true);
          } 
        else {
          setEntryRatioValid_1(false);
          }
        };
    const handleEntryRatio_2 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_2(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_2(true);
          } 
        else {
          setEntryRatioValid_2(false);
          }
        };
    const handleEntryRatio_3 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_3(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_3(true);
          } 
        else {
          setEntryRatioValid_3(false);
          }
        };
    const handleEntryRatio_4 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_4(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_4(true);
          } 
        else {
          setEntryRatioValid_4(false);
          }
        };
    const handleEntryRatio_5 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_5(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_5(true);
          } 
        else {
          setEntryRatioValid_5(false);
          }
        };
    const handleEntryRatio_6 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_6(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_6(true);
          } 
        else {
          setEntryRatioValid_6(false);           
          }
        };
    const handleEntryRatio_7 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_7(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_7(true);
          } 
        else {
          setEntryRatioValid_7(false);
          }
        };
    const handleEntryRatio_8 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_8(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_8(true);
          } 
        else {
          setEntryRatioValid_8(false);
          }
        };
    const handleEntryRatio_9 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_9(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_9(true);
          } 
        else {
          setEntryRatioValid_9(false);
          }
        };
    
    const handleCoverratio = (e) => {
      const newCoverRatio = e.target.value.trim();
      setCoverRatio(newCoverRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newCoverRatio)) {
          setCoverratioValid(true);
          } 
        else {
          setCoverratioValid(false);
          }
        };

    const handleAddSymbol = (symbol) => {
      const confirmed = window.confirm(`${symbol}을 리스트에 추가할까요?`);
      if (confirmed) {
      fetch(`/add_user_symbols_royal?uid=${uid}&symbol=${symbol}`)
      .then(res => res.json())
      .then(data => {
        if (data.msg) {
            alert(data.msg); // msg가 존재할 때만 출력
            return;
          }
        setSymbolList(data.signal)
      })
      .catch(err => console.error(err));
      }
    };

    const deleteSymbol = (symbol) => {
      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      const confirmed = window.confirm(`${symbol}이 포지션이 걸려 있다면 리스트에서 삭제 후 수동으로 포지션 정리해주세요! ${symbol}을 삭제하시겠습니까?`);
      if (confirmed) {
      fetch(`/delete_user_symbols_royal?uid=${uid}&symbol=${symbol}`)
      .then(res => res.json())
      .then(data => setSymbolList(data.signal))
      .catch(err => console.error(err));
      removeListItem(symbol, setE_Items);
      removeListItem(symbol, setW_Items);
      setSymbol('default')
      }
    };

    const handleClosePopup = () => {
      setIsPopupOpen(false);
    };        

    const addListItem = (newItem, listSetter) => {
      listSetter(prevList => 
        prevList.includes(newItem) ? prevList : [...prevList, newItem]
      );
    };

    const removeListItem = (itemName, listSetter) => {
      listSetter(prevList => prevList.filter(item => item !== itemName));
    };
    
    const onClickCoin = (coin) => {
      setSymbol(coin);
      onClickSearch(coin);
    }

    useEffect(() => {

      if(firstusdtValid && leverageValid && turningratioValid && totalbenefitValid && crossbenefitValid &&
        benefitratioValid && losscutratioValid && standardratioValid && entryusdtValid_1 && entryusdtValid_2 && entryusdtValid_3 && entryusdtValid_4 &&
        entryusdtValid_5 && entryusdtValid_6 && entryusdtValid_7 && entryusdtValid_8 && entryusdtValid_9 &&
        entryratioValid_1 && entryratioValid_2 && entryratioValid_3 && entryratioValid_4 &&
        entryratioValid_5 && entryratioValid_6 && entryratioValid_7 && entryratioValid_8 && entryratioValid_9 &&
        coverratioValid) {
        setNotAllow(false);
        return;
      }
      setNotAllow(true);
    }, [firstusdtValid, leverageValid, turningratioValid, totalbenefitValid, crossbenefitValid,
      benefitratioValid, losscutratioValid, standardratioValid, entryusdtValid_1, entryusdtValid_2, entryusdtValid_3, entryusdtValid_4,
      entryusdtValid_5, entryusdtValid_6, entryusdtValid_7, entryusdtValid_8, entryusdtValid_9, entryratioValid_1, entryratioValid_2,
      entryratioValid_3, entryratioValid_4, entryratioValid_5, entryratioValid_6, entryratioValid_7, entryratioValid_8, entryratioValid_9,
      coverratioValid]);

    useEffect(() => {
        fetch(`/get_user_symbols_royal?uid=${uid}`)
        .then(res => res.json())
        .then(data => setSymbolList(data.signal))
        .catch(err => console.error(err));
    },[symbol,uid]);

    const onClickSearch = (symbol) => {
      let urlName
      const str = symbol;
      console.log(str);
      const uidurl = uid;
      if(str === 'default'){
        urlName = 'default'
      }else{
        const index = str.indexOf('/');
        urlName = str.substring(0,index);
      }  
      fetch(`/setdata_royal/${uidurl}/${urlName}/${setlevel}`)
      .then((response) => {
        if(!response.ok) {
          throw new Error('400 아니면 500 에러남');
        }
        return response.json()
      })
      .then((result) => {
        console.log('db에서 성공적으로 데이터 받아옴');
        setFirstUsdt(result[0].first_usdt);
        setLeverage(result[0].leverage_info);
        setTurningRatio(result[0].turning_ratio);
        
        setTotalBenefit(result[0].total_benefit);
        setCrossBenefit(result[0].cross_benefit);

        setBenefitRatio(result[0].benefit_ratio);
        setLosscutRatio(result[0].losscut_ratio);

        setStandardRatio(result[0].standard_ratio);

        setEntryUsdt_1(result[0].entry_usdt_1);
        setEntryUsdt_2(result[0].entry_usdt_2);
        setEntryUsdt_3(result[0].entry_usdt_3);
        setEntryUsdt_4(result[0].entry_usdt_4);
        setEntryUsdt_5(result[0].entry_usdt_5);
        setEntryUsdt_6(result[0].entry_usdt_6);
        setEntryUsdt_7(result[0].entry_usdt_7);
        setEntryUsdt_8(result[0].entry_usdt_8);
        setEntryUsdt_9(result[0].entry_usdt_9);

        setEntryRatio_1(result[0].entry_ratio_1);
        setEntryRatio_2(result[0].entry_ratio_2);
        setEntryRatio_3(result[0].entry_ratio_3);
        setEntryRatio_4(result[0].entry_ratio_4);
        setEntryRatio_5(result[0].entry_ratio_5);
        setEntryRatio_6(result[0].entry_ratio_6);
        setEntryRatio_7(result[0].entry_ratio_7);
        setEntryRatio_8(result[0].entry_ratio_8);
        setEntryRatio_9(result[0].entry_ratio_9);

        setCoverRatio(result[0].cover_ratio);

        setEntryCandle(result[0].entry_candle);
        setMode(result[0].mode);

        setTradeStart(result[0].trade_start);
        setBenefit_stop(result[0].current_symbol_stop);
        setCurrentCoin_stop(result[0].current_coin_clear);
        setAllCoin_stop(result[0].all_coin_clear);
        setEnd(result[0].end);

        const e_checklist = isItemInList(result[0].symbol, e_items);
        const w_checklist = isItemInList(result[0].symbol, w_items);
        
        if(str !== 'default'){
          result.forEach(item => {
            // console.log('item',item)
            if ((item.trade_start === 1 || item.trade_start === '1') && e_checklist === false) {
              addListItem(item.symbol, setE_Items);
            }
            if ((item.trade_start === 0 || item.trade_start === '0') && e_checklist === true) {
              removeListItem(item.symbol, setE_Items);
            }
          
            // Waiting coin 리스트 삽입 및 삭제
            if ((item.current_symbol_stop === 1 || item.current_symbol_stop === '1') && w_checklist === false) {
              addListItem(item.symbol, setW_Items);
            }
            if ((item.current_symbol_stop === 0 || item.current_symbol_stop === '0') && w_checklist === true) {
              removeListItem(item.symbol, setW_Items);
            }
          });
        };

        console.log('e_items',e_items);
        console.log('e_checklist',e_checklist);
      })
      .catch((error) => {
        console.log('에러남');
      })
    }

    const onClickStart = async () => {
      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      
      try {
        let confirmed = false

        if (trade_start === 0 || trade_start === "0"){
          confirmed = window.confirm(symbol + '의 매매를 시작하시겠습니까?');
        }else if (trade_start === 1 || trade_start === "1"){
          confirmed = window.confirm(symbol + '의 셋팅값을 변경하시겠습니까?');
        }
        
        if (confirmed) {
          console.log('스타트 버튼 클릭');
          
          const startResponse = await fetch('/start_royal', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              uid,
              symbol,
              first_usdt,
              leverage_info,
              turning_ratio,
              total_benefit,
              cross_benefit,
              benefit_ratio,
              losscut_ratio,
              standard_ratio,
              entry_usdt_1,
              entry_usdt_2,
              entry_usdt_3,
              entry_usdt_4,
              entry_usdt_5,
              entry_usdt_6,
              entry_usdt_7,
              entry_usdt_8,
              entry_usdt_9,
              entry_ratio_1,
              entry_ratio_2,
              entry_ratio_3,
              entry_ratio_4,
              entry_ratio_5,
              entry_ratio_6,
              entry_ratio_7,
              entry_ratio_8,
              entry_ratio_9,
              cover_ratio,
              entry_candle,
              mode
            }),
          });
          
          const startData = await startResponse.json();  // 응답을 JSON 형식으로 변환
          onClickSearch(symbol);
          alert(startData.message);  // JSON에서 message 값을 가져옴
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    const autoTradeStart = (seed) => {

      if (seed === "basic") {
        alert('자동 매매 시드를 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }

      const uidurl = uid;

      alert('시드 자동 셋팅 매매는 안정적인 매매법의 추천값이지 절대값은 아님을 알려드립니다. 시장의 변동성에 따라 손실이 발생할 수 있음을 미리 인지하시고 본인의 판단에 따라 적절히 활용하세요');

      const confirmed = window.confirm(seed + ' USDT 기준의 자동매매를 시작하시겠습니까?');

      if (confirmed) {
        fetch(`/auto_start_leverage/${uidurl}/${seed}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('auto_start에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
        window.location.reload()
        // onClickSearch('default');
      };
      };

    // 익절 후 정리
    const onClickBenefit_stop = (symbol) => {
      const confirmed = window.confirm('Do you want to clean up the selected coin after profiting?');

      if (confirmed) {
        setBenefit_stop(true);
        let urlName
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_royal/${uidurl}/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
          })
        };
      onClickSearch(symbol);
    }

    // 익절 후 정리 취소 
    const onClickBenefit_cancel = (symbol) => {
      const confirmed = window.confirm('Do you want to cancel clearing after profiting the selected coins?');

      if (confirmed) {
        setBenefit_cancel(true);
        let urlName
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_cancel_royal/${uidurl}/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit_cancel에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }

    // 현재 코인 정리 
    const onClickCurrentCoin_stop = (symbol) => {
      const confirmed = window.confirm('Would you like to liquidate the selected coins right away?');

      if (confirmed) {
        setCurrentCoin_stop(true);
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        const index = str.indexOf('/');
        const urlName = str.substring(0,index);
        fetch(`/setdata_current_coin_clear_royal/${uidurl}/${urlName}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('current_stop에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }

    //진입중인 모든 코인 정리
    const onClickAllCoin_stop = () => {
      const confirmed = window.confirm('Do you really want to liquidate all coins that are currently entering the market?');

      if (confirmed) {
        setAllCoin_stop(true);
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        const index = str.indexOf('/');
        const urlName = str.substring(0,index);
        fetch(`/setdata_all_coin_clear_royal/${uidurl}/${urlName}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('current_stop에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }

    //로그아웃
    const onClickEnd = () => {
        const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
        if (!uuid) {
          alert('로그인 정보가 존재하지 않습니다.');
          return;
        }
        // 로그아웃 요청을 서버로 보냅니다.
        fetch('/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ userId: uuid })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('로그아웃 요청 실패');
          }
          console.log('로그아웃 성공');
          alert('Logout is successful.');
          window.location.href = '/';
        })
        .catch(error => {
          console.error('로그아웃 요청 중 오류 발생:', error);
        });
      // UUID를 서버로 보내는 예시 코드

    }

    return (
        <div className="page_sp_leverage">
          <div className="title_top_sp">
            <div></div>
            <div className="titleWrap_sp_lever">
            Bitsoop auto trade system (Royal version)</div>
            <div className="inputTitle_uid_lever">
                <span>UID : {uid}</span>
                <span>{nickname}님 환영합니다</span>
            </div>
          </div>

          <div className="line_top"></div>

            <div className="container">
              <div className="column_leverage">
              <div className="button_benefit_leverage">
              <select className="usdt_select_lv_samaria" 
                value = {symbol} 
                onChange={(e) => {setSymbol(e.target.value); 
                                  onClickSearch(e.target.value);}}>
                <option value="">symbol select</option>
                {symbolList.map((sym, idx) => (
                    <option key={idx} value={sym}>{sym}</option>
                ))}
              </select>
              <button onClick={() => setIsPopupOpen(true)} disabled={!symbol} className="button_benefit_c_ut">
                추 가
              </button>
              <button onClick={() => deleteSymbol(symbol)} disabled={!symbol} className="button_benefit_c_ut">
                삭 제
              </button>
              </div>
              {/* 팝업은 여기서 조건부 렌더링 */}
              <div>
                <SymbolSearchPopup
                  isOpen={isPopupOpen}
                  onAdd={handleAddSymbol}
                  onClose={handleClosePopup}
                  />
              </div>

            <div className="contentWrap_sp">

            <div className="line"></div>

            <div className="center_text_lever">Basic setting</div>
              <div class="leverage_container">
                <div class="leverage_item">First entry USDT</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={first_usdt}
                onChange={handleFirstUsdt} />
                <div class="leverage_item">Set Leverage</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={leverage_info}
                onChange={handleLeverage} />
              </div>
              <div class="leverage_container">
                <div class="leverage_item">Turning Trend Rate(%)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={turning_ratio}
                onChange={handleTurningratio} />
                <div class="leverage_item">Cross Minimum Profit Ratio(%)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={cross_benefit}
                onChange={handleCrossbenefit} />
              </div>
              <div class="leverage_container">
                <div class="leverage_item">Benfit set(%)</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={benefit_ratio}
                onChange={handleBenefitratio} />
                <div class="leverage_item">Losscut set(%)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={losscut_ratio}
                onChange={handleLosscutratio} />
              </div>
              <div class="leverage_container">
                <div class="leverage_item">Total Benfit set(USDT)</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={total_benefit}
                onChange={handleTotalBenefit} />
                <div class="leverage_item">Complementary entry rate(%)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={cover_ratio}
                onChange={handleCoverratio} />
              </div>
            
            {/* 레버리지 셋팅  레버리지 셋팅 레버리지 셋팅 레버리지 셋팅 레버리지 셋팅*/}
            <div className="line"></div>
              <div class="leverage_container">
                <div class="leverage_item">1st set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_1}
                onChange={handleEntryUsdt_1} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_1}
                onChange={handleEntryRatio_1} />
                {/* <div class="leverage_item leverage_hidden">Entry interval(%)</div>
                <input type="text" class="leverage_input leverage_hidden" /> */}
              </div>

              <div class="leverage_container">
                <div class="leverage_item">2nd set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_2}
                onChange={handleEntryUsdt_2} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_2}
                onChange={handleEntryRatio_2} />
              </div>

              <div class="leverage_container">
                <div class="leverage_item">3rd set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_3}
                onChange={handleEntryUsdt_3} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_3}
                onChange={handleEntryRatio_3} />
              </div>

              <div class="leverage_container">
                <div class="leverage_item">4th set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_4}
                onChange={handleEntryUsdt_4} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_4}
                onChange={handleEntryRatio_4} />
              </div>

              <div class="leverage_container">
                <div class="leverage_item">5th set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_5}
                onChange={handleEntryUsdt_5} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_5}
                onChange={handleEntryRatio_5} />
              </div>

              <div class="leverage_container">
                <div class="leverage_item">6th set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_6}
                onChange={handleEntryUsdt_6} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_6}
                onChange={handleEntryRatio_6} />
              </div>

              <div class="leverage_container">
                <div class="leverage_item">7th set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_7}
                onChange={handleEntryUsdt_7} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_7}
                onChange={handleEntryRatio_7} />
              </div>

              <div class="leverage_container">
                <div class="leverage_item">8th set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_8}
                onChange={handleEntryUsdt_8} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_8}
                onChange={handleEntryRatio_8} />
              </div>

              <div class="leverage_container">
                <div class="leverage_item">9th set</div>
                <div class="leverage_item">Entry USDT</div>
                <input 
                type="number"
                step="1"
                class="leverage_input"
                value={entry_usdt_9}
                onChange={handleEntryUsdt_9} />
                <div class="leverage_item">Standard interval</div>
                <input
                type="number"
                class="leverage_input"
                value={entry_ratio_9}
                onChange={handleEntryRatio_9} />
              </div>
            
              <div className="leverage_container">
                <div class="leverage_item">Entry standard Candle</div>
                <select className="select_samaria" value={entry_candle} onChange={handleEntryCandle}>
                  <option value="1m">1 M candle</option>
                  <option value="3m">3 M candle</option>
                  <option value="5m">5 M candle</option>
                  <option value="15m">15 M candle</option>
                </select>
                <div class="leverage_item">Mode select</div>
                <select className="select_samaria" value={mode} onChange={handleMode}>
                  <option value='forward'>Forward</option>
                  <option value='reverse'>Reverse</option>
                </select>
              </div>

            <div className="line"></div>
            
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickStart()} className="bottomButton_sp_lever">
                Trading start
                </button>
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickBenefit_stop(symbol)} disabled={benefit_stop === 1 || trade_start === 0 || benefit_stop === '1' || trade_start === '0'} className="button_benefit_c_lever">
                Clean up after profit
                </button>
                <button onClick={() => onClickBenefit_cancel(symbol)} disabled={benefit_stop === '0' || benefit_stop === 0} className="button_benefit_c_lever">
                Cancel
                </button>
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickCurrentCoin_stop(symbol)} disabled={(symbol === 'default' && trade_start === 0 &&  benefit_stop === 0) || (symbol === 'default' && trade_start === '0' &&  benefit_stop === '0') || setlevel <= 7} className="bottomButton_sp_lever">
                Current symbol close
                </button>
                {/* <button onClick={() => onClickAllCoin_stop()} disabled={symbol === 'default' && setlevel <= 7} className="button_benefit_c_lever">
                All symbol close
                </button> */}
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickEnd()} disabled={notAllow} className="bottomButton_sp_lever">
                Log out
                </button>
             </div>
          </div>


          <div className="column_leverage">
              <div className="list_box_title_lever">Entry coins</div>
              <ul className="list_box_lever">
                {e_items.map((item, index) => (
                  <li
                    key={index}
                    className="list_item"
                    onClick={() => onClickCoin(item)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
          </div>

          <div className="column_leverage">
            <div className="list_box_title_lever">Waiting coins</div>
              <ul className="list_box_lever">
                {w_items.map((item, index) => (
                  <li
                    key={index}
                    className="list_item"
                    onClick={() => onClickCoin(item)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
    );
}